import { Stack } from "@certn/cascadia";
import { Link, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { SectionSchema } from "./types";
import { isQuickscreenBasePath } from "./utils";

interface Props {
  incompleteSectionsWithNoSummary?: SectionSchema[];
  caseId: string;
  basePath?: string;
}

// Some sections are hidden from the summary, this adds those incomplete sections to a list to be displayed in a sectionMessage
export function IncompleteSectionWarning(props: Props) {
  const basePath = props.basePath ?? "apply";
  const { t } = useTranslation();

  if (
    !props.incompleteSectionsWithNoSummary ||
    props.incompleteSectionsWithNoSummary?.length === 0
  ) {
    return null;
  }

  return (
    <SectionMessage
      type="danger"
      icon="error"
      sectionTitle={
        isQuickscreenBasePath(basePath)
          ? t(
              "These sections must be completed before submitting the application."
            )
          : t(
              "We need to complete these sections before you can submit your application."
            )
      }
    >
      <Stack gap="space-2">
        {props.incompleteSectionsWithNoSummary?.map((section) => (
          <Link
            linkStyle="monochrome"
            testID={`incomplete-section-link-${section.name}`}
            key={section.name}
            href={`/${basePath}/${props.caseId}/${section.name}`}
          >
            {section.label}
          </Link>
        ))}
      </Stack>
    </SectionMessage>
  );
}
